/**
 * Asset Vuex module: unified state, mutations, actions, and getters.
 */
const state = {
    isEdit: false,
};

const mutations = {
    SET_IS_EDIT(state, value) {
        state.isEdit = value;
    },
};

const actions = {
    setIsEdit({ commit }, value) {
        commit('SET_IS_EDIT', value);
    },
};

const getters = {
    isEdit: (state) => state.isEdit,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};